module.exports = __webpack_public_path__ + "static/media/1POLICY27.f7e8c1ff.jpg";